import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "small text-danger"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", null, "Email", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.authData.username) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkName()))
      }, null, 544), [
        [_vModelText, _ctx.user.authData.username]
      ]),
      (!_ctx.usernameOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Email già utilizzata"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("label", null, "Password", -1)),
      (_ctx.$route.params.identifier == '0')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "form-control",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.authData.password) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.user.authData.password]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("input", {
              class: "form-control",
              type: "password",
              value: "xxxxxxxxxxx",
              readonly: true
            }, null, -1)),
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
            }, " Cambia password ")
          ]))
    ])
  ]))
}